import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinchichwad() {



const cardData = {
  keyword: " Cab Service in Chinchwad  ",

"headingDescription": "SRS Cab Service offers Cab Service in Chinchwad, providing reliable, comfortable, and safe transportation for daily commuting, business trips, airport transfers, and leisure travel. Our well-maintained vehicles, professional drivers, and punctual service ensure a smooth and hassle-free journey across Chinchwad and nearby areas. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service is your trusted partner for convenient and enjoyable travel.",
"topPlaces": [
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is one of the most revered temples in the area. Travelers using Cab Service in Chinchwad from SRS Cab Service often visit for spiritual experiences and local festivities."
  },
  {
    "title": "Rahate Colony Park",
    "description": "Rahate Colony Park is a peaceful green space ideal for walking, relaxation, and family outings. Visitors using SRS Cab Service often include this park in their leisure trips."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a bustling commercial area with shopping and local eateries. Travelers using SRS Cab Service often explore this market for dining and shopping."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and outdoor activities. Visitors using SRS Cab Service often attend matches or enjoy recreational activities here."
  },
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "This spiritual site attracts devotees from around the region. Travelers using SRS Cab Service often visit for blessings and cultural experiences."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "An educational and family-friendly destination, this park is perfect for interactive learning and leisure visits. Visitors using SRS Cab Service frequently include it in their itinerary."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub in Chinchwad, this area is often visited by business travelers using SRS Cab Service for professional engagements."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar offers fun rides and entertainment for families and children. Travelers using SRS Cab Service often plan visits for leisure and recreation."
  },
  {
    "title": "Sinhgad Institute of Technology",
    "description": "An important educational landmark, often visited by students and families. Visitors using SRS Cab Service may explore nearby attractions while traveling here."
  },
  {
    "title": "Pimpri Chinchwad Cultural Center",
    "description": "This cultural hub hosts events, exhibitions, and performances. Travelers using SRS Cab Service often attend shows to experience local art and culture."
  }
],



services: [
{
name: "Chinchwad Cab Service",
description: "Chinchwad cab service offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Chinchwad",
description: "Taxi service in Chinchwad provides convenient travel for local and intercity routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Chinchwad Taxi Service",
description: "Chinchwad taxi service offers dependable transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Chinchwad",
description: "Cab booking Chinchwad provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Chinchwad",
description: "Taxi booking Chinchwad offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Chinchwad",
description: "Cab near Chinchwad helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Chinchwad",
description: "Taxi near Chinchwad offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Chinchwad",
description: "Best cab service in Chinchwad provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Chinchwad",
description: "Cheap cab service Chinchwad offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Chinchwad",
description: "Affordable cab service Chinchwad provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Chinchwad Cab Hire",
description: "Chinchwad cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Chinchwad Taxi Hire",
description: "Chinchwad taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Chinchwad Cab for Airport",
description: "Chinchwad cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Chinchwad Airport Cab Service",
description: "Chinchwad airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Chinchwad Cab for Outstation",
description: "Chinchwad cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Chinchwad Pune",
description: "Cab service Chinchwad Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Chinchwad Pune",
description: "Taxi service Chinchwad Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Chinchwad Pune",
description: "Cab booking Chinchwad Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab Chinchwad",
description: "Innova cab Chinchwad offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab Chinchwad",
description: "Innova Crysta cab Chinchwad provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Chinchwad",
description: "Ertiga cab Chinchwad offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Chinchwad",
description: "Dzire cab Chinchwad provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab Chinchwad",
description: "Sedan cab Chinchwad offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab Chinchwad",
description: "Luxury cab Chinchwad provides premium travel experience for corporate and special trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller Chinchwad",
description: "Tempo traveller Chinchwad offers group travel solutions for family and corporate trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Best Cab Service in Chinchwad for Airport Drop",
description: "Best cab service in Chinchwad for airport drop provides reliable transfer for passengers. Customers can book cabs for timely airport travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Affordable Cab Service Chinchwad for Outstation",
description: "Affordable cab service Chinchwad for outstation offers cost-effective travel solutions. Customers can book cabs for long-distance journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Chinchwad Cab Service for Office Travel",
description: "Chinchwad cab service for office travel provides reliable transportation for employees. Companies can book cabs for daily office commutes. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate cab services."
},
{
name: "Reliable Taxi Service Chinchwad Pune",
description: "Reliable taxi service Chinchwad Pune offers dependable transportation for customers. Users can book taxis for daily and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Chinchwad Near Me",
description: "Cab booking Chinchwad near me helps customers find nearby cabs instantly. Users can book rides anytime for local and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Urbania on Rent Chinchwad",
description: "Urbania on rent Chinchwad offers luxury group travel for family and corporate trips. Customers can book premium vehicles for outstation journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
}
],

tableData: [
["Chinchwad Cab Service","Taxi Service in Chinchwad"],
["Chinchwad Taxi Service","Cab Booking Chinchwad"],
["Taxi Booking Chinchwad","Cab Near Chinchwad"],
["Taxi Near Chinchwad","Best Cab Service in Chinchwad"],
["Cheap Cab Service Chinchwad","Affordable Cab Service Chinchwad"],
["Chinchwad Cab Hire","Chinchwad Taxi Hire"],
["Chinchwad Cab for Airport","Chinchwad Airport Cab Service"],
["Chinchwad Cab for Outstation","Cab Service Chinchwad Pune"],
["Taxi Service Chinchwad Pune","Cab Booking Chinchwad Pune"],
["Innova Cab Chinchwad","Innova Crysta Cab Chinchwad"],
["Ertiga Cab Chinchwad","Dzire Cab Chinchwad"],
["Sedan Cab Chinchwad","Luxury Cab Chinchwad"],
["Tempo Traveller Chinchwad","Urbania on Rent Chinchwad"]
],



whychoose: [
  {
    WhyChooseheading: "Local Expertise in Chinchwad Area",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service in Chinchwad with drivers familiar with local routes, MIDC areas, and nearby locations like Pimpri, Akurdi, and Nigdi."
  },
  {
    WhyChooseheading: "Affordable Cab Service in Chinchwad",
    WhyChoosedescription: "We offer budget-friendly cab services in Chinchwad with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Chinchwad, making it convenient for daily travel, office commutes, airport transfers, and emergency bookings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride within Chinchwad and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for all travel needs."
  },
  {
    WhyChooseheading: "Quick Pickup & Doorstep Service",
    WhyChoosedescription: "We provide fast pickup from homes, offices, industrial areas, and societies across Chinchwad and nearby locations."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite behavior, and a reliable travel experience for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Chinchwad",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and businesses in Chinchwad for punctual service, affordable pricing, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Chinchwad?", answer: "Yes, SRS Cab Service offers reliable cab services in Chinchwad for local and outstation travel." },
  { question: "Is cab service available 24 hours in Chinchwad?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Chinchwad?", answer: "Yes, we provide Pune Airport pickup and drop services from Chinchwad." },
  { question: "Which areas do you cover near Chinchwad?", answer: "We cover Pimpri, Akurdi, Nigdi, Wakad, Bhosari, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book cab online in Chinchwad?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way and outstation cab?", answer: "Yes, we provide one-way and outstation cab services from Chinchwad." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Jadhav",
    feedback:
      "Booked cab from Chinchwad to airport. Very quick service and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Chinchwad. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];





















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Chinchwad Cab Service | SRS Cab Service",
  "description": "Reliable and affordable cab service in Chinchwad, Pune. Offering local rides, airport transfers, and outstation trips with Innova, Ertiga, and Sedan cabs. 24/7 taxi service for corporate and personal travel.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Chinchwad",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411019",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6311",
    "longitude": "73.8036"
  },
  "url": "https://www.srscabservice.com/chinchwad-cab-service",
  "areaServed": [
    "Chinchwad", "Pimpri", "Bhosari", "Akurdi", "Nigdi"
  ],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Chinchwad Cab Service",
    "Local and Outstation Cabs",
    "Airport Transfers",
    "Innova, Ertiga, Sedan Cab Hire"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "580"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Chinchwad Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book reliable cabs in Chinchwad, Pune. Affordable Innova, Ertiga, and Sedan cabs for local rides, airport transfers, and outstation trips. 24/7 taxi service for corporate and personal travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinchichwad;